import StageSanDiego, { getServerSideProps } from './SanDiego';
export default StageSanDiego;
export { getServerSideProps };
